import {
  SET_NO_ONE_ON_CALL_OPEN,
  GET_SHIFT_GAPS_FOR_GROUPS_SUCCESS,
} from 'actions/noOneOnCall';

export const defaultState = {
  groupNames: [],
  startDates: [],
  endDates: [],
  isOpen: false,
};

export default function noOneOnCallReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_NO_ONE_ON_CALL_OPEN:
      if (!action.payload) {
        return { ...defaultState };
      }

      return { ...state, isOpen: action.payload };
    case GET_SHIFT_GAPS_FOR_GROUPS_SUCCESS: {
      return { ...state, isOpen: true, gaps: action.payload };
    }
    default:
      return state;
  }
}
